import { useQuery, useMutation, useQueryClient } from 'react-query';
import { UserHttpService } from 'core/services/user';

const useJobExperiences = (cvId = null) => {
    const queryClient = useQueryClient();

    // Query for fetching job experiences
    const { data, isLoading, error } = useQuery(['jobExperiences', cvId], async () => {
        const response = await UserHttpService.listJobExperiences(cvId);
        return response.results || [];
    });

    // Mutation for adding a job experience
    const addJobExperienceMutation = useMutation(
        async (newJobExperience) => {
            return await UserHttpService.createJobExperience(newJobExperience);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch job experiences query
                queryClient.invalidateQueries(['jobExperiences', cvId]);
            }
        }
    );

    // Mutation for updating a job experience
    const updateJobExperienceMutation = useMutation(
        async (updatedJobExperience) => {
            return await UserHttpService.updateJobExperience(updatedJobExperience.id, updatedJobExperience);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch job experiences query
                queryClient.invalidateQueries(['jobExperiences', cvId]);
            }
        }
    );

    // Mutation for deleting a job experience
    const deleteJobExperienceMutation = useMutation(
        async (id) => {
            return await UserHttpService.deleteJobExperience(id);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch job experiences query
                queryClient.invalidateQueries(['jobExperiences', cvId]);
            }
        }
    );

    return {
        jobExperiences: data || [],
        isLoading,
        error: error ? error.message : null,
        addJobExperience: addJobExperienceMutation.mutateAsync,
        updateJobExperience: updateJobExperienceMutation.mutateAsync,
        deleteJobExperience: deleteJobExperienceMutation.mutateAsync
    };
};

export default useJobExperiences; 